import { render, staticRenderFns } from "./MatchManage.vue?vue&type=template&id=e0c75496&scoped=true&"
import script from "./MatchManage.vue?vue&type=script&lang=js&"
export * from "./MatchManage.vue?vue&type=script&lang=js&"
import style0 from "./MatchManage.vue?vue&type=style&index=0&id=e0c75496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c75496",
  null
  
)

export default component.exports